import { isValid, parse } from "date-fns";
import { parseDateRangeInternal, parseDateRange, formatDateRange, STANDARD_DATE_FORMAT } from "./dates.js";
const ARRAY_DELIMITER = ",";
const FORMAT_VERBOSE = "FORMAT_VERBOSE";
const guessDateFormat = (dateString) => {
  if (dateString.length <= 21) {
    return STANDARD_DATE_FORMAT;
  }
  return FORMAT_VERBOSE;
};
const parseDateFromString = (dateString, formatString) => {
  if (formatString === FORMAT_VERBOSE) {
    return new Date(dateString);
  }
  return parse(dateString, formatString, /* @__PURE__ */ new Date());
};
const stringArrayConverter = {
  fromAttribute: (attr) => (attr == null ? void 0 : attr.split(ARRAY_DELIMITER).map((v) => v.trim()).filter((v) => !!v)) || [],
  toAttribute: (value) => {
    if (!value) {
      return "";
    }
    if (typeof value === "string") {
      return value;
    }
    return value.join(ARRAY_DELIMITER);
  }
};
const dateAttributeConverter = {
  fromAttribute: (attr) => {
    if (!attr) {
      return void 0;
    }
    const date = parseDateFromString(attr, guessDateFormat(attr));
    return isValid(date) ? date : void 0;
  }
};
const dateListAttributeConverter = {
  fromAttribute: (attr) => {
    if (!attr) {
      return [];
    }
    const parts = attr.split(ARRAY_DELIMITER).filter((part) => !!part).map((part) => part.trim());
    return parts.map((part) => {
      const formatString = guessDateFormat(part);
      if (formatString === FORMAT_VERBOSE) {
        const date = parseDateFromString(part, formatString);
        return isValid(date) ? date : part;
      }
      return part;
    }).filter((date) => !!date);
  }
};
const dateRangeAttributeConverter = {
  fromAttribute: (attr) => {
    if (!attr) {
      return [];
    }
    const parts = attr.split(ARRAY_DELIMITER);
    const formatString = guessDateFormat(parts[0]);
    const dateRange = formatString === FORMAT_VERBOSE ? parseDateRangeInternal(attr, ARRAY_DELIMITER, (str) => new Date(str)) : parseDateRange(attr, formatString, ARRAY_DELIMITER);
    const [fromDate, toDate] = dateRange;
    if (fromDate && !isValid(fromDate) || toDate && !isValid(toDate)) {
      return [];
    }
    return dateRange;
  },
  toAttribute: (val) => val ? formatDateRange(val, STANDARD_DATE_FORMAT, ARRAY_DELIMITER) : ""
};
export {
  dateAttributeConverter,
  dateListAttributeConverter,
  dateRangeAttributeConverter,
  stringArrayConverter
};
